"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_dropzone_1 = __importDefault(require("react-dropzone"));
// //
// // components
// //
const GenericInput_1 = __importDefault(require("components/general/inputs/GenericInput"));
const FormValidation_1 = require("components/general/utility/FormValidation");
//
// assets
//
const trackingCopy_1 = require("copy/trackingCopy");
//
// styles
//
const StyledModalHeader_1 = require("components/Dashboard/Modals/StyledModalHeader");
const StyledModalHeaderContainer_1 = require("components/Dashboard/Modals/StyledModalHeaderContainer");
const StyledCloseIcon_1 = require("components/Dashboard/Modals/StyledCloseIcon");
const StyledFilePrompt_1 = require("components/Dashboard/Modals/StyledFilePrompt");
const StyledIcon_1 = require("components/Dashboard/Modals/StyledIcon");
const StyledPromptText_1 = require("components/Dashboard/Modals/StyledPromptText");
const StyledButtonsContainer_1 = require("components/Dashboard/Modals/StyledButtonsContainer");
const StyledButton_1 = require("components/Dashboard/StyledButton");
const StyledTimestamp_1 = require("components/Dashboard/TrackingPageManager/TrackingPageCard/StyledTimestamp");
const LocalAccount_1 = __importDefault(require("LocalAccount"));
const FilterDropdown_1 = __importDefault(require("components/Dashboard/FilterDropdown"));
const MalomoText_1 = require("components/Dashboard/MalomoText");
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const AuthContext_1 = require("AuthContext");
const StyledFeatherIcon_1 = require("components/Dashboard/NavigationSidebar/StyledFeatherIcon");
const config_1 = require("assets/styles/config");
const UploadIndicator_1 = __importDefault(require("./UploadIndicator"));
const TrackingPageModal = (props) => {
    const [name, setName] = (0, react_1.useState)('');
    const [file, setFile] = (0, react_1.useState)([]);
    const [nameError, setNameError] = (0, react_1.useState)('');
    const [hostedDomain, setHostedDomain] = (0, react_1.useState)({});
    const [uploadInProgress, setUploadInProgress] = (0, react_1.useState)(false);
    const { logout } = (0, react_1.useContext)(AuthContext_1.AuthContext);
    (0, react_1.useEffect)(() => {
        var _a;
        setName(((_a = props === null || props === void 0 ? void 0 : props.page) === null || _a === void 0 ? void 0 : _a.name) || '');
        setFile([]);
        setUploadInProgress(false);
    }, [props.page]);
    (0, react_1.useEffect)(() => {
        if (props.display) {
            document.body.style.overflow = 'hidden';
        }
        else {
            setFile([]);
            document.body.removeAttribute('style');
        }
    }, [props.display]);
    function handleClick(event) {
        if (event.target.id === 'modal-root') {
            props.onToggleModal();
        }
    }
    function handleBlur(event) {
        const error = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (error) {
            if (event.target.id === 'name') {
                setNameError(error);
            }
        }
        else if (event.target.id === 'name') {
            setNameError('');
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'name') {
            setName(event.target.value);
        }
    }
    function genericModal({ modalHeader, modalText, primaryButtonText, primaryButtonOnClick }) {
        return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: {
                display: `${props.display ? 'block' : 'none'}`
            }, tabIndex: -1 },
            react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
                react_1.default.createElement("div", { className: 'modal-content' },
                    react_1.default.createElement(StyledModalHeaderContainer_1.StyledModalHeaderContainer, { className: 'card-header' },
                        react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title', id: 'exampleModalCenterTitle' }, modalHeader),
                        react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: props.onToggleModal, type: 'button' },
                            react_1.default.createElement(StyledCloseIcon_1.StyledCloseIcon, { "aria-hidden": 'true' }, "\u00D7"))),
                    react_1.default.createElement("div", { className: 'card-body' },
                        react_1.default.createElement(StyledTimestamp_1.StyledTimestamp, null, modalText),
                        react_1.default.createElement(StyledButtonsContainer_1.StyledButtonsContainer, null,
                            react_1.default.createElement(MalomoButton_1.MalomoButton, { id: 'cancel', onClick: props.onToggleModal, secondary: true }, trackingCopy_1.trackingCopy.modalButton1),
                            react_1.default.createElement(StyledButton_1.StyledButton, { className: 'btn btn-primary', id: 'archive-page', minWidth: '85px', onClick: primaryButtonOnClick }, primaryButtonText)))))));
    }
    function fileUploadDesign() {
        let fileName = '';
        try {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'never'.
            fileName = file[0].name;
        }
        catch (e) {
            // browsers be tripping with file access sometimes, so we provide a backup just in case
            fileName = 'ZIP file selected.';
        }
        if (file.length === 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-upload', size: '20px' }),
                react_1.default.createElement(StyledPromptText_1.StyledPromptText, null, trackingCopy_1.trackingCopy.uploadPrompt)));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-folder', size: '20px' }),
            react_1.default.createElement(StyledPromptText_1.StyledPromptText, null, fileName),
            uploadInProgress ? (react_1.default.createElement(UploadIndicator_1.default, { progress: props.progress })) : null));
    }
    function uploadFile(fn) {
        setUploadInProgress(true);
        fn();
    }
    function renderEditPageModal() {
        return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: {
                display: `${props.display ? 'block' : 'none'}`
            }, tabIndex: -1 },
            react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
                react_1.default.createElement("div", { className: 'modal-content' },
                    react_1.default.createElement(StyledModalHeaderContainer_1.StyledModalHeaderContainer, { className: 'card-header' },
                        react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title', id: 'exampleModalCenterTitle' }, trackingCopy_1.trackingCopy.modalHeader2),
                        react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: props.onToggleModal, type: 'button' },
                            react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-x', color: config_1.colors.thundercloud }))),
                    react_1.default.createElement("div", { className: 'card-body' },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(GenericInput_1.default, { error: nameError, id: 'name', label: trackingCopy_1.trackingCopy.modalLabel1, onBlur: handleBlur, onInputChange: handleInputChange, value: name }),
                            react_1.default.createElement(GenericInput_1.default, { disabled: true, id: 'url', label: trackingCopy_1.trackingCopy.modalLabel2, onBlur: handleBlur, onInputChange: handleInputChange, value: [props.page.hostedDomain.token, props.page.slug].join('/') })),
                        uploadInProgress ? (react_1.default.createElement("div", null,
                            react_1.default.createElement(StyledFilePrompt_1.StyledFilePrompt, null, fileUploadDesign()))) : (react_1.default.createElement(react_dropzone_1.default, { accept: '.zip', maxFiles: 1, 
                            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'T[]' is not assignable to parame... Remove this comment to see the full error message
                            onDrop: (acceptedFiles) => setFile(acceptedFiles) }, ({ getRootProps, getInputProps }) => (react_1.default.createElement(StyledFilePrompt_1.StyledFilePrompt, Object.assign({}, getRootProps()),
                            react_1.default.createElement("input", Object.assign({}, getInputProps())),
                            fileUploadDesign())))),
                        props.progress === 0 ? (react_1.default.createElement(StyledButtonsContainer_1.StyledButtonsContainer, null,
                            react_1.default.createElement(MalomoButton_1.MalomoButton, { id: 'cancel', onClick: props.onToggleModal, secondary: true }, trackingCopy_1.trackingCopy.modalButton1),
                            react_1.default.createElement(MalomoButton_1.MalomoButton, { disabled: !name, id: 'update-page', minWidth: '85px', onClick: () => uploadFile(() => props.onUpdate(props.page.id, name, file)) }, trackingCopy_1.trackingCopy.modalButtonEdit))) : null)))));
    }
    function renderNewPageModal() {
        let hostedDomains;
        try {
            hostedDomains = LocalAccount_1.default.get().hostedDomains.edges.map((edge) => edge.node);
        }
        catch (e) {
            // presumably the hosted domains are not present, we need to re-auth the user
            logout();
            return null;
        }
        let showHostedDomains = true;
        if (hostedDomains.length === 1) {
            showHostedDomains = false;
            if (JSON.stringify(hostedDomain) !== JSON.stringify(hostedDomains[0])) {
                setHostedDomain(hostedDomains[0]);
            }
        }
        const hostedDomainOptions = hostedDomains.map((domain) => {
            return Object.assign(Object.assign({}, domain), { label: domain.token });
        });
        const createButtonEnabled = () => {
            return (file.length === 1 && JSON.stringify(hostedDomain) !== JSON.stringify({}));
        };
        return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: {
                display: `${props.display ? 'block' : 'none'}`
            }, tabIndex: -1 },
            react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
                react_1.default.createElement("div", { className: 'modal-content' },
                    react_1.default.createElement(StyledModalHeaderContainer_1.StyledModalHeaderContainer, { className: 'card-header' },
                        react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title', id: 'exampleModalCenterTitle' }, trackingCopy_1.trackingCopy.modalHeader1),
                        react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: props.onToggleModal, type: 'button' },
                            react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-x', color: config_1.colors.thundercloud }))),
                    react_1.default.createElement("div", { className: 'card-body' },
                        react_1.default.createElement(GenericInput_1.default
                        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ defaultValue: string; error: string; id: s... Remove this comment to see the full error message
                        , { 
                            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ defaultValue: string; error: string; id: s... Remove this comment to see the full error message
                            defaultValue: '', error: nameError, id: 'name', label: trackingCopy_1.trackingCopy.modalLabel1, onBlur: handleBlur, onInputChange: handleInputChange }),
                        showHostedDomains && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(MalomoText_1.MalomoText, { label: true }, "Domain"),
                            react_1.default.createElement(FilterDropdown_1.default, { callback: (selection) => setHostedDomain(selection), margin: { top: 10, bottom: 20 }, options: hostedDomainOptions, wide: true }))),
                        uploadInProgress ? (react_1.default.createElement("div", null,
                            react_1.default.createElement(StyledFilePrompt_1.StyledFilePrompt, null, fileUploadDesign()))) : (react_1.default.createElement(react_dropzone_1.default, { accept: '.zip', maxFiles: 1, 
                            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'T[]' is not assignable to parame... Remove this comment to see the full error message
                            onDrop: (acceptedFiles) => setFile(acceptedFiles) }, ({ getRootProps, getInputProps }) => (react_1.default.createElement(StyledFilePrompt_1.StyledFilePrompt, Object.assign({}, getRootProps()),
                            react_1.default.createElement("input", Object.assign({}, getInputProps())),
                            fileUploadDesign())))),
                        props.progress === 0 ? (react_1.default.createElement(StyledButtonsContainer_1.StyledButtonsContainer, null,
                            react_1.default.createElement(MalomoButton_1.MalomoButton, { id: 'cancel', onClick: props.onToggleModal, secondary: true }, trackingCopy_1.trackingCopy.modalButton1),
                            react_1.default.createElement(MalomoButton_1.MalomoButton, { disabled: !createButtonEnabled(), id: 'update-page', minWidth: '85px', onClick: () => uploadFile(() => props.onCreate(name, file, hostedDomain)) }, trackingCopy_1.trackingCopy.modalButtonNew))) : null)))));
    }
    if (props.type === 'delete') {
        return genericModal({
            modalHeader: trackingCopy_1.trackingCopy.modalHeader3,
            modalText: trackingCopy_1.trackingCopy.modalLabel3,
            primaryButtonText: trackingCopy_1.trackingCopy.modalButtonDelete,
            primaryButtonOnClick: props.onDelete
        });
    }
    else if (props.type === 'archive') {
        return genericModal({
            modalHeader: trackingCopy_1.trackingCopy.modalHeader3,
            modalText: trackingCopy_1.trackingCopy.modalLabel4,
            primaryButtonText: trackingCopy_1.trackingCopy.modalButtonArchive,
            primaryButtonOnClick: props.onArchive
        });
    }
    else if (props.type === 'restore') {
        return genericModal({
            modalHeader: trackingCopy_1.trackingCopy.modalHeader3,
            modalText: trackingCopy_1.trackingCopy.modalRestoreLabel,
            primaryButtonText: trackingCopy_1.trackingCopy.modalButtonRestore,
            primaryButtonOnClick: props.onRestore
        });
    }
    else if (props.type === 'new') {
        return renderNewPageModal();
    }
    else if (props.type === 'edit') {
        return renderEditPageModal();
    }
    return null;
};
TrackingPageModal.propTypes = {
    display: prop_types_1.default.bool,
    onArchive: prop_types_1.default.func,
    onCreate: prop_types_1.default.func,
    onDelete: prop_types_1.default.func,
    onRestore: prop_types_1.default.func,
    onToggleModal: prop_types_1.default.func,
    onUpdate: prop_types_1.default.func,
    page: prop_types_1.default.shape({
        id: prop_types_1.default.string,
        name: prop_types_1.default.string,
        slug: prop_types_1.default.string,
        hostedDomain: prop_types_1.default.shape({
            id: prop_types_1.default.string,
            token: prop_types_1.default.string
        })
    }),
    progress: prop_types_1.default.number,
    type: prop_types_1.default.string
};
exports.default = TrackingPageModal;
